import { render, staticRenderFns } from "./NotificationBell.vue?vue&type=template&id=b908bd30&scoped=true&"
import script from "./NotificationBell.vue?vue&type=script&lang=js&"
export * from "./NotificationBell.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBell.vue?vue&type=style&index=0&id=b908bd30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b908bd30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b908bd30')) {
      api.createRecord('b908bd30', component.options)
    } else {
      api.reload('b908bd30', component.options)
    }
    module.hot.accept("./NotificationBell.vue?vue&type=template&id=b908bd30&scoped=true&", function () {
      api.rerender('b908bd30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/NotificationBell/NotificationBell.vue"
export default component.exports